import { Info } from "lucide-react";

/**
 * Why a flow run's report is not generated on open (Rupert PR-1865 r2).
 *
 * The Analysis surface generates a flow run's report automatically only when
 * the flow run's own rollup (`flow_runs[]` on `GET /api/runs`) says it has
 * settled. Without one — `GET /api/runs` failed, or an older server sent none —
 * the steps in view cannot prove every step has finished, so the report is
 * left to the user's "Generate report" button, and this says why.
 *
 * `scope` words it for one flow run (its page) or for the list.
 */
export function SettlementUnknownNotice({
  feedFailed,
  scope,
}: {
  feedFailed: boolean;
  scope: "flow-run" | "list";
}): JSX.Element {
  const cause = feedFailed
    ? "Could not load whether flow runs have finished"
    : "This server does not report whether a flow run has finished";
  const consequence =
    scope === "flow-run"
      ? "so this report is not generated automatically. Generate it below once every step has finished."
      : "so flow runs are listed with their status unknown, and their reports are not generated automatically.";
  return (
    <div
      role="status"
      className="flex items-center gap-2 rounded-md border bg-surface-2 px-4 py-3 text-xs text-muted-foreground"
    >
      <Info className="h-4 w-4 shrink-0" aria-hidden />
      <span>
        {cause}, {consequence}
      </span>
    </div>
  );
}
